import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Typography } from '@material-ui/core'

import {
  Container,
  ContentHeader,
  LoadingFeedback,
  Page,
  SectionCard,
} from 'components'
import { SolicitationForm } from './components'

const HelpCenterSolicitation = () => {
  const [loading, setLoading] = useState(false)

  const location = useLocation()

  const searchParams = new URLSearchParams(location.search)
  const category = searchParams.get('category')

  return (
    <Page title="Solicitar atendimento">
      <Container maxWidth={false}>
        <ContentHeader title="Solicitar atendimento" />
        <LoadingFeedback open={loading} />
        <SectionCard
          title={
            <Typography variant="h5">Formulário de solicitação</Typography>
          }
        >
          <SolicitationForm category={category} setLoading={setLoading} />
        </SectionCard>
      </Container>
    </Page>
  )
}

export default HelpCenterSolicitation
